import {
  BusinessType,
  CountryList,
  SalesChannel,
} from "client/lib/apt-merchant";
import { determineSecondBankFormEligibility } from "client/lib/apt-merchant/src/fields/bankInformation/utils";
import { BankFieldSetNames } from "client/lib/apt-merchant/src/fieldsets";

const plaidEligibleCountries: CountryList[] = ["United States", "Canada"];

const eligibleCountryToBusinessType: Record<CountryList, BusinessType[]> = {
  "United States": ["Sole Proprietorship", "Corporation", "LLC"],
  Canada: ["Sole Proprietorship", "Corporation", "Partnership"],
  Australia: [],
  "New Zealand": [],
  "United Kingdom": [],
};

export const isEligibleForPlaid = ({
  businessType,
  registeredCountry,
}: {
  businessType?: BusinessType;
  registeredCountry?: CountryList;
}): boolean => {
  if (!registeredCountry || !businessType) {
    return false;
  }
  return (
    plaidEligibleCountries.includes(registeredCountry) &&
    eligibleCountryToBusinessType[registeredCountry].includes(businessType)
  );
};

export const getPlaidBankAccountName = ({
  businessType,
  legalBusinessName,
  firstOwnerFullName,
}: {
  businessType?: BusinessType;
  legalBusinessName?: string;
  firstOwnerFullName: string;
}): string => {
  const corpType = ["Corporation", "LLC", "Partnership"];
  const defaultName = "No name provided";
  if (businessType && corpType.includes(businessType)) {
    return legalBusinessName ?? defaultName;
  }
  if (businessType === "Sole Proprietorship") {
    return firstOwnerFullName;
  }
  return defaultName;
};

export const getSetBankFormComplete = ({
  fieldSetName,
  salesChannel,
  registeredCountry,
}: {
  fieldSetName: BankFieldSetNames;
  salesChannel?: SalesChannel;
  registeredCountry?: CountryList;
}): boolean => {
  if (
    fieldSetName === "SecondaryBankFieldSet" ||
    !determineSecondBankFormEligibility({
      salesChannel,
      registeredCountry,
    })
  ) {
    return true;
  }
  return false;
};
